// Client to server events
export enum GameClientEvents {
  JOIN_GAME = 'joinGame',
  LEAVE_GAME = 'leaveGame',
  MOVE_SNAKE = 'moveSnake',
  PLAYER_INPUT = 'player_input',
  USE_ATTACK = 'useAttack',
  USE_POWER_UP = 'usePowerUp',
  SWITCH_POWER_UP = 'switchPowerUp',
  TARGET_CHANGED = 'targetChanged',
  REMATCH = 'rematch',
}

// Server to client events
export enum GameServerEvents {
  GAME_STATE_UPDATE = 'gameStateUpdate',
  GAME_START = 'gameStart',
  GAME_OVER = 'gameOver',
  GAME_ENDED = 'gameEnded',
  ATTACK_INCOMING = 'attackIncoming',
  PLAYER_JOINED = 'playerJoined',
  PLAYER_LEFT = 'playerLeft',
  POWER_UP_USED = 'powerUpUsed',
  SNAKE_MOVED = 'snakeMoved',
  SERVER_TICK = 'server_tick',
  MATCH_TIMER = 'match_timer',
  MOVE_SENT = 'moveSent',
  ATTACK_SENT = 'attackSent',
  INPUT_RECEIVED = 'input_received',
  REMATCH_WAITING = 'rematch_waiting',
  REMATCH_START = 'rematch_start',
  TARGET_UPDATE = 'targetUpdate',
  PLAYER_DISCONNECTED = 'playerDisconnected',
  PLAYER_RECONNECTED = 'playerReconnected',
  RECONNECT_SUCCESS = 'reconnectSuccess',
  RECONNECT_FAILED = 'reconnectFailed',
  COUNTDOWN_CANCELLED = 'countdownCancelled',
}

// Room management events (client to server)
export enum RoomClientEvents {
  REGISTER_USERNAME = 'registerUsername',
  CREATE_ROOM = 'createRoom',
  JOIN_ROOM = 'joinRoom',
  VERIFY_ROOM_PASSWORD = 'verifyRoomPassword',
  LEAVE_ROOM = 'leaveRoom',
  GET_ALL_ROOMS = 'getAllRooms',
  RECONNECT = 'reconnect',
  START_GAME = 'startGame',
}

// Room management events (server to client)
export enum RoomServerEvents {
  WELCOME = 'welcome',
  ROOM_CREATED = 'roomCreated',
  ROOM_JOINED = 'roomJoined',
  ROOM_LEFT = 'roomLeft',
  ROOMS_UPDATED = 'roomsUpdated',
  ALL_ROOMS = 'allRooms',
  ERROR = 'error',
  PLAYER_TOKEN = 'playerToken',
}

// Matchmaking events (client to server)
export enum MatchmakingClientEvents {
  JOIN_QUEUE = 'joinQueue',
  LEAVE_QUEUE = 'leaveQueue',
}

// Matchmaking events (server to client)
export enum MatchmakingServerEvents {
  QUEUE_UPDATE = 'queueUpdate',
  MATCHED = 'matched',
}

// Ready-up events (client to server)
export enum ReadyClientEvents {
  PLAYER_READY = 'playerReady',
}

// Ready-up events (server to client)
export enum ReadyServerEvents {
  READY_UPDATE = 'readyUpdate',
  COUNTDOWN_START = 'countdownStart',
  MATCH_START = 'matchStart',
  READY_ACK = 'readyAck',
}
